import { Component, ElementRef, ViewChild, Inject, ɵConsole } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { DefTiposEscritura, EscrituraModel} from './Escritura.model';
import { MchInformacionEscrituraId } from './Escritura.model';

import { OpcionModel } from '../Global/Opcion.model';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
	selector: 'EscrituraEdit',
	templateUrl: './EscrituraEdit.component.html',
	styleUrls: ['../../../../styles.css']
})


export class EscrituraEditComponent {

	public tiposEscrituras: Array<OpcionModel>;
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
	public form: FormGroup;
	public formErrors: any;
	public escritura: EscrituraModel;
	public bloquearLlaves: boolean = false;
	public bloquearLlavesDescripcion: boolean = false;
	public guardando: boolean = false;
	public ccodconTemp: string = '';
	public cnumcontTemp: string = '';
	public ciddocTemp: string = '';
	public banderaEditar:  boolean = false;

	public ocultar: boolean = false;
	public mensaje: string = "";


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();
		
		this.formErrors = {
			vidEscritura:{},
			cantidadCompradores:{},
			vdescripcion:{},
			nvalor:{},
			vobservacion:{},
			ncostos:{},
			ntipoescritura: {}
		};
		this.escritura = new EscrituraModel(new MchInformacionEscrituraId("","",""),0,"",0,"",0,0,0,0,'',new Date(),new DefTiposEscritura(""));
	}
	
	onBlurMethod(valor,campo){

		let temp = /\./gi;

		valor = valor.replace(temp,'').replace('$','').replace(',','.');

		console.log(campo);
		console.log(valor);
		console.log(Number(valor));
		

		if(!isNaN(Number(valor)) && campo == 'inmueble'){
			this.escritura.nvalor = Number(valor);
		}

		

		if( !isNaN(Number(valor))  && campo == 'costos'){
			this.escritura.ncostos = Number(valor);
		}

		console.log("Valor inmueble : "+this.escritura.nvalor);
		console.log("Valor costos : "+this.escritura.ncostos);

	}

	ngOnInit() {
		this.inicializarFormulario("", "", "");

		this._route.params.subscribe(params => {

			this.ccodconTemp = params['vidEscritura'];
			this.cnumcontTemp = params['cnumcont'];
			this.ciddocTemp = params['cprefijo'];
			
		

			if (params['editar'] == 0) {

				this.inicializarFormulario("", "", "");
				this.escritura = new EscrituraModel(new MchInformacionEscrituraId("",params['cnumcont'], params['cprefijo']),0,"",0,"",0,0,0,0,'',new Date(),new DefTiposEscritura("0"));

			} else if (params['editar'] == 1) {

				this.bloquearLlaves = true;
				this.banderaEditar = true;

				this._serviciosGenerales.get('detalleEscritura', { cnumcont: params['cnumcont'], vidEscritura: params['vidEscritura'], cprefijo: params['cprefijo'] }).subscribe(
					result => {
						let x = result[0];
						this.escritura = new EscrituraModel(new MchInformacionEscrituraId(params['vidEscritura'],params['cnumcont'],params['cprefijo']),x.cantidadCompradores,x.vdescripcion,x.nvalor,x.vobservacion,x.ncostos,x.ndocumento,x.ndocumentocostos,x.nvalida,'',new Date(), new DefTiposEscritura(x.ntipoescritura));
					
						if (parseInt(x.c) > 0) {
							this.bloquearLlavesDescripcion = true;
						}

						this.inicializarFormulario(this.cnumcontTemp, this.ccodconTemp, x.vidEscritura.trim());

					}, error => {
						var errorMensaje = <any>error;
						this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
					})
			}
			this.tiposEscrituras = new Array();

			this._serviciosGenerales.get('tiposEscrituras', { param: 0 }).subscribe(
				result => {
					for (let x in result) {
						this.tiposEscrituras.push(new OpcionModel(result[x].ntipoescritura, result[x].vdescripcion));
					}
				},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de escrituras", "X");
				})
			

		});
	}


	

	guardar() {

		
		if (this.escritura.nvalor <= 0) {
			this.openSnackBarEspecial("El Valor del Inmueble no puede ser menor o igual a 0.", "X");
			return;
		}
		
		if (this.escritura.ncostos <= 0) {
			this.openSnackBarEspecial("El Valor Costos no puede ser menor o igual a 0.", "X");
			return;
		}
		
		
		if(this.escritura.id.vidEscritura==''){
			this.openSnackBarEspecial("El campo Id Escritura no puede estar vacio.", "X");
			return;
		}
		
		if(this.escritura.cantidadCompradores<=0 ||this.escritura.cantidadCompradores>10){
			this.openSnackBarEspecial("El valor del campo Cantidad Terceros Compradores debe ser mayor a cero y menor o igual a 10", "X");
			return;
		}
		
		if(this.escritura.vdescripcion.trim()==''){
			this.openSnackBarEspecial("El campo Descripción Inmueble no puede estar vacio.", "X");
			return;
		}
		
		if(this.escritura.vobservacion.trim()==''){
			this.openSnackBarEspecial("El campo Observaciones no puede estar vacio.", "X");
			return;
		}
		
		if (this.form.valid == false) {
			this.openSnackBarEspecial("Hay campos obligatorios por llenar...", "X");
			return;
		}
		
		this._serviciosGenerales.get('validarSiExisteEscritura', { cnumcont: this.cnumcontTemp, vidEscritura: this.escritura.id.vidEscritura.toString(), cprefijo: this.ciddocTemp }).subscribe(
			result => {
				
				if (result[0].c > 0 && this.bloquearLlaves == false) {
					this.openSnackBarEspecial("El Id Escritura: " + this.escritura.id.vidEscritura + " para el contrato: " + this.cnumcontTemp + " y prefijo: " + this.ciddocTemp + " ya existe en el sistema", "X");
					return;
				}
				
				this.guardarSinValidaciones();
				
			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
			});			
	}


	guardarSinValidaciones() {
		this.escritura.vusuario = this._serviciosGenerales.seguridad.getInfoSesion().usuario;
		this.escritura.dfecsist = new Date();


		if (this.banderaEditar) {
			
			this._serviciosGenerales.delete('pasarInformacionLogEscritura', {cnumcont: this.cnumcontTemp, vidEscritura: this.escritura.id.vidEscritura, cprefijo: this.ciddocTemp}).subscribe(
				result=>{
					
					console.log('XXXXXXXXXXXXXXXXXX   ',result.error)
					if(!result.error){
						console.log(' --------------------------- CONDICION= '+this.banderaEditar)
						this.guardando = true;
						this._serviciosGenerales.post('guardar/escritura', this.escritura).subscribe(result => {
			
							this.openSnackBar("Escritura Guardada correctamente", "X");
				
							setTimeout(() => {
								this._router.navigate(['/Escritura', this.cnumcontTemp, this.ciddocTemp]);
							}, 2000)		
						}, error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de guardar la Escritura", "X");
							this.guardando = false;
						})
						}
				},error=>{
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de insertar en la tabla de LOG", "X");
				})	
				
		}else{
			this.guardando = true;
			//this.escritura.nvalida = 3;
		this._serviciosGenerales.post('guardar/escritura', this.escritura).subscribe(result => {
			this.openSnackBar("Escritura Guardada correctamente", "X");

			setTimeout(() => {
				this._router.navigate(['/Escritura', this.cnumcontTemp, this.ciddocTemp]);
			}, 2000)



		}, error => {
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de guardar la Escritura.............", "X");
			this.guardando = false;
		})
		}	
	}

	inicializarFormulario(valor1, valor2, valorDescripcion) {
		this.form = this.formBuilder.group({
			vidEscritura: [{ disabled: this.bloquearLlaves, value: valor2 }, Validators.required],
			cantidadCompradores: ['', Validators.required],
			vdescripcion: ['', Validators.required],
			nvalor:[0, Validators.required],
			vobservacion: ['', Validators.required],
			ncostos:[0, Validators.required],
			ntipoescritura:['', Validators.required]
		});
/*

		console.log("VA A INICIALIZAR FORM : ", this.bloquearLlavesDescripcion);
		this.form = this.formBuilder.group({
			cdescon: [{ disabled: this.bloquearLlavesDescripcion, value: valorDescripcion }, Validators.required],
			ccodcon: [{ disabled: this.bloquearLlaves, value: valor2 }, Validators.required],
			cctacxc: ['', Validators.required],
			cctaiva: ['', Validators.required],
			cingveniva: ['', Validators.required],
			ntipoiva: ['',Validators.required],
			nporcentaje: [0, Validators.required],
			nporcentajeimpuestoconsumo: [0, Validators.required],
			cfidudeb: ['', Validators.required],
			ncuentaimpuestoconsumo: ['', Validators.required]
		});

		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});
		*/
	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}






// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/CrearEscritura/EscrituraEdit.component.ts